export enum PermissionType {
    None = 0,
    Accepted = 1,
    DelegatedOutPolicy = 2,
    DelegatedInPolicy = 3,
    DeniedOutPolicy = 4,
    DeniedInPolicy = 5,
    DeniedVRConflictByChild = 6
}

export enum PolicyType {
    None = 0,
    InPolicy = 1,
    OutOfPolicy = 2,
    OutOfPolicyByEnforceSchedulingHorizon = 3,
    OutOfPolicyByBookingWindowInDays = 4,
    OutOfPolicyByMaximumDurationInMinutes = 5
}